/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
    PalAuthSubmissionStatusUpdatedByUserToJSONTyped,
} from './PalAuthSubmissionStatusUpdatedByUser';

/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadWaitlistUpdatesInner
 */
export interface PalAuthSubmissionLeadWaitlistUpdatesInner {
    /**
     * 
     */
    waitlist_id?: string;
    /**
     * 
     */
    comment?: string;
    /**
     * 
     */
    created_by_user_id?: string;
    /**
     * 
     */
    created_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     */
    created_at?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionLeadWaitlistUpdatesInner interface.
 */
export function instanceOfPalAuthSubmissionLeadWaitlistUpdatesInner(value: object): value is PalAuthSubmissionLeadWaitlistUpdatesInner {
    return true;
}

export function PalAuthSubmissionLeadWaitlistUpdatesInnerFromJSON(json: any): PalAuthSubmissionLeadWaitlistUpdatesInner {
    return PalAuthSubmissionLeadWaitlistUpdatesInnerFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadWaitlistUpdatesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadWaitlistUpdatesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'waitlist_id': json['waitlist_id'] == null ? undefined : json['waitlist_id'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'created_by_user_id': json['created_by_user_id'] == null ? undefined : json['created_by_user_id'],
        'created_by_user': json['created_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['created_by_user']),
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function PalAuthSubmissionLeadWaitlistUpdatesInnerToJSON(json: any): PalAuthSubmissionLeadWaitlistUpdatesInner {
    return PalAuthSubmissionLeadWaitlistUpdatesInnerToJSONTyped(json, false);
}

export function PalAuthSubmissionLeadWaitlistUpdatesInnerToJSONTyped(value?: PalAuthSubmissionLeadWaitlistUpdatesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'waitlist_id': value['waitlist_id'],
        'comment': value['comment'],
        'created_by_user_id': value['created_by_user_id'],
        'created_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['created_by_user']),
        'created_at': value['created_at'],
    };
}

